import { render } from "./GestorMetas.vue?vue&type=template&id=263f9496"
import script from "./GestorMetas.vue?vue&type=script&lang=js"
export * from "./GestorMetas.vue?vue&type=script&lang=js"

import "./GestorMetas.vue?vue&type=style&index=0&id=263f9496&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__